/**
 * Access mode for the current pilot round.
 *
 * During the invite-only feedback round (docs/archive/pilot-feedback-round-plan.md §8.6)
 * open self-registration is soft-locked: the landing page leads with "Zaloguj
 * się" instead of "Załóż konto", and `/signup` shows an invite-only notice
 * rather than the registration form. Doctors get in through a personal magic
 * link (`/invite`), not the public form.
 *
 * This is a soft (client-side) lock — it hides the path, it does not enforce it
 * server-side. Reopened 2026-10-22 for the open beta: anyone can register with
 * a PWZ, and the founders verify each account by hand on /admin/doctors. If a
 * hard gate is ever needed, enforce it in `before_user_created` (reject emails
 * not on the invite allowlist), not here.
 */
export const INVITE_ONLY = false;

/** Contact address shown on invite-only surfaces. */
export const INVITE_CONTACT_EMAIL = 'chariot@o7k.pl';
